// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body,html{width:100%;min-width:-webkit-fit-content;min-width:-moz-fit-content;min-width:fit-content;margin:0;padding:0;overflow:auto}.body{max-width:100vw;min-height:calc(100vh - 300px)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
